"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
  return r;
};
/* eslint-disable no-param-reassign */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */

function isEmptyObject(obj) {
  for (var prop in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, prop)) {
      return false;
    }
  }
  return true;
}
function isEqual(obj, obj1) {
  return JSON.stringify(obj) === JSON.stringify(obj1);
}
// useEffect监听数组的变化的变量处理方法
function useCampare(value, compare) {
  var ref = _react["default"].useRef([]);
  if (!compare(value, ref.current)) {
    ref.current = [].concat(value);
  }
  return ref.current;
}
var LIGHTHOUSE_MOUDLE_CODE = 'lighthouse';
var DiscountPurchaseCardItem = function DiscountPurchaseCardItem(props) {
  var _onClick = props.onClick,
    // 卡片点击弹窗购买
    onCardChangeTime = props.onCardChangeTime,
    onCardChangeResouse = props.onCardChangeResouse,
    _a = props.data,
    data = _a === void 0 ? {} : _a,
    clickKey = props.clickKey,
    updateCard = props.updateCard,
    updateSdkAppInfo = props.updateSdkAppInfo,
    colorTheme = props.colorTheme,
    onNormalNumChange = props.onNormalNumChange,
    modelText = props.modelText,
    onNormalBuyClick = props.onNormalBuyClick,
    // 卡片点击购买
    onFreeBuyClick = props.onFreeBuyClick,
    // 走领劵逻辑
    layoutMode = props.layoutMode,
    sdkAppInfos = props.sdkAppInfos,
    // 企业版sdkAppIds
    onCardChangeSdkAppId = props.onCardChangeSdkAppId;
  var _b = data.title,
    title = _b === void 0 ? '' : _b,
    _c = data.desc,
    desc = _c === void 0 ? '' : _c,
    _d = data.cardDiscount,
    cardDiscount = _d === void 0 ? '' : _d,
    _e = data.cardOriginal,
    cardOriginal = _e === void 0 ? '' : _e,
    _f = data.textList,
    textList = _f === void 0 ? [] : _f,
    _g = data.timeInfoList,
    timeInfoList = _g === void 0 ? [] : _g,
    _h = data.cardDefaultSelect,
    cardDefaultSelect = _h === void 0 ? {} : _h,
    _j = data.skuList,
    skuList = _j === void 0 ? {} : _j,
    _k = data.timeText,
    timeText = _k === void 0 ? '时长' : _k,
    _l = data.queryPriceText,
    queryPriceText = _l === void 0 ? '询价中...' : _l,
    _m = data.createOrderText,
    createOrderText = _m === void 0 ? 'Purchasing' : _m,
    _o = data.isQueryPrice,
    isQueryPrice = _o === void 0 ? true : _o,
    _p = data.isCreateOrder,
    isCreateOrder = _p === void 0 ? false : _p,
    _q = data.btnTxt,
    btnTxt = _q === void 0 ? 'buy now' : _q,
    _r = data.defaultPurchaseNum,
    defaultPurchaseNum = _r === void 0 ? 1 : _r,
    _s = data.eventId,
    eventId = _s === void 0 ? '' : _s,
    _t = data.ecId,
    ecId = _t === void 0 ? '' : _t,
    _u = data.isNoDiscount,
    isNoDiscount = _u === void 0 ? false : _u,
    _v = data.isConnect,
    isConnect = _v === void 0 ? false : _v,
    _w = data.hasNoModel,
    hasNoModel = _w === void 0 ? false : _w,
    _x = data.eventType,
    eventType = _x === void 0 ? '20' : _x,
    _y = data.href,
    href = _y === void 0 ? '' : _y,
    _z = data.extendProps,
    extendProps = _z === void 0 ? '' : _z,
    _0 = data.moduleCode,
    moduleCode = _0 === void 0 ? '' : _0,
    _1 = data.spuInfo,
    spuInfo = _1 === void 0 ? {} : _1,
    _2 = data.timeShow,
    timeShow = _2 === void 0 ? '' : _2,
    _3 = data.resouseText,
    resouseText = _3 === void 0 ? '' : _3,
    _4 = data.sdkAppText,
    sdkAppText = _4 === void 0 ? '' : _4,
    _5 = data.resouseListShow,
    resouseListShow = _5 === void 0 ? [] : _5,
    _6 = data.description,
    description = _6 === void 0 ? '' : _6,
    supplement = data.supplement,
    _7 = data.hasSdkAppId,
    hasSdkAppId = _7 === void 0 ? false : _7;
  var selectSku = "sku_" + cardDefaultSelect.regionId;
  var range = spuInfo.goodsNum || {};
  var goodsNum = range.range || {};
  var isLightHouse = !moduleCode || LIGHTHOUSE_MOUDLE_CODE === moduleCode.toLocaleLowerCase();
  var skuListIsArray = Array.isArray(skuList);
  var skuListWithTxt = [];
  var sku = {
    skuId: '',
    priceParam: '{}',
    regionId: 0,
    timeSpan: 0,
    timeUnit: 0
  };
  var resouseShow = '';
  if (skuListIsArray && !isLightHouse) {
    if (skuList.length >= 1) {
      skuListWithTxt = skuList.map(function (item, index) {
        var textObj = resouseListShow[index] || {};
        var txt = textObj.txt;
        return __assign(__assign({}, item), {
          text: txt || ''
        });
      });
      sku = skuList[0] || {};
      if (skuListWithTxt.length === 1) {
        resouseShow = skuListWithTxt[0].text;
      }
    }
  }
  var orderInfo = {
    eventId: '',
    ecId: '',
    orderInfo: {
      price: 0,
      skuId: '',
      purchaseNum: 1,
      params: [],
      regionId: 0,
      timeSpan: 0,
      timeUnit: 0
    }
  };
  var _8 = (0, _react.useState)(0),
    timeSelectIndex = _8[0],
    setTimeSelectIndex = _8[1];
  var _9 = (0, _react.useState)(0),
    resouseSelectIndex = _9[0],
    setResouseSelectIndex = _9[1];
  var _10 = (0, _react.useState)(0),
    sdkAppIdSelectIndex = _10[0],
    setSdkAppIdSelectIndex = _10[1];
  var _11 = (0, _react.useState)(cardDiscount),
    discount = _11[0],
    setDiscount = _11[1];
  var _12 = (0, _react.useState)(cardOriginal),
    original = _12[0],
    setOriginal = _12[1];
  var _13 = (0, _react.useState)(cardDefaultSelect),
    selectProduce = _13[0],
    setSelectProduce = _13[1];
  var _14 = (0, _react.useState)(sku),
    selectResouse = _14[0],
    setSelectResouse = _14[1];
  var _15 = (0, _react.useState)(isQueryPrice),
    queryPrice = _15[0],
    setQueryPrice = _15[1];
  var _16 = (0, _react.useState)(isCreateOrder),
    createOrder = _16[0],
    setCreateOrder = _16[1];
  var _17 = (0, _react.useState)(goodsNum.min || 1),
    purchaseNum = _17[0],
    setPurchaseNum = _17[1];
  var _18 = (0, _react.useState)(false),
    isResouseClick = _18[0],
    setIsResouseClick = _18[1];
  var _19 = (0, _react.useState)(false),
    isSdkAppIdClick = _19[0],
    setIsSdkAppIdClick = _19[1];
  var _20 = (0, _react.useState)(''),
    resourceId = _20[0],
    setResourceId = _20[1];
  var _21 = (0, _react.useState)(''),
    licenseExpireTime = _21[0],
    setLicenseExpireTime = _21[1];
  var _22 = (0, _react.useState)(0),
    sdkAppId = _22[0],
    setSdkAppId = _22[1];
  var dropDownButton = (0, _react.useRef)(null);
  var listArr = useCampare(sdkAppInfos, isEqual);
  var setTimeAndPrice = function setTimeAndPrice(index, e) {
    e.stopPropagation(); // 阻止冒泡
    var selectTime = timeInfoList[index];
    var selectSkuIndex = skuList[selectSku + "_" + selectTime.timeUnit + "_" + selectTime.timeSpan];
    var parentElem = e.currentTarget.parentElement.parentElement;
    var parentElemClass = parentElem.classList;
    var isChooseSame = index === timeSelectIndex;
    setTimeSelectIndex(index);
    setSelectProduce(__assign(__assign({}, selectProduce), {
      timeUnit: selectTime.timeUnit,
      timeSpan: selectTime.timeSpan
    }));
    if (parentElemClass.contains('active')) {
      parentElem.classList.remove('active');
    } else {
      parentElem.classList.add('active');
    }
    // 时间切换时传递的数据
    onCardChangeTime({
      cardItemIndex: clickKey,
      skuId: selectSkuIndex,
      timeUnit: selectTime.timeUnit,
      timeSpan: selectTime.timeSpan,
      regionId: cardDefaultSelect.regionId,
      bluePrintId: cardDefaultSelect.blueprintId,
      defaultPurchaseNum: defaultPurchaseNum,
      eventId: eventId,
      ecId: ecId,
      isChooseSame: isChooseSame
    });
  };
  var setResouseChange = function setResouseChange(index, e) {
    e.stopPropagation(); // 阻止冒泡
    var sku = skuListWithTxt[index];
    var isChooseSame = index === resouseSelectIndex;
    setResouseSelectIndex(index);
    setSelectResouse(sku);
    setIsResouseClick(false);
    var skuId = sku.skuId || '';
    var regionId = sku.regionId || 0;
    var timeSpan = sku.timeSpan || 0;
    var timeUnit = sku.timeUnit || 0;
    var priceParam = JSON.parse(sku.priceParam);
    priceParam.goodsNum = purchaseNum;
    onCardChangeResouse({
      cardItemIndex: clickKey,
      skuId: skuId,
      regionId: regionId,
      timeSpan: timeSpan,
      timeUnit: timeUnit,
      priceParam: JSON.stringify(priceParam),
      purchaseNum: purchaseNum,
      eventId: eventId,
      ecId: ecId,
      isChooseSame: isChooseSame
    });
  };
  var setSdkAppInfoChange = function setSdkAppInfoChange(index, e) {
    e.stopPropagation(); // 阻止冒泡
    var sdkAppInfo = sdkAppInfos[index];
    var isChooseSame = index === sdkAppIdSelectIndex;
    setSdkAppIdSelectIndex(index);
    setIsSdkAppIdClick(false);
    onCardChangeSdkAppId({
      cardItemIndex: clickKey,
      isChooseSame: isChooseSame,
      sdkAppId: sdkAppInfo.ID
    });
  };
  var toggleActive = function toggleActive(e) {
    var target = e.currentTarget;
    var targetClassList = target.classList;
    if (targetClassList.contains('active')) {
      target.classList.remove('active');
    } else {
      target.classList.add('active');
    }
  };
  var toggleResouseActive = function toggleResouseActive() {
    setIsResouseClick(!isResouseClick);
  };
  var toggleSdkAppIdActive = function toggleSdkAppIdActive() {
    setIsSdkAppIdClick(!isSdkAppIdClick);
  };
  var handleMouseLeave = function handleMouseLeave() {
    var target = dropDownButton.current;
    if (target) {
      var targetClassList = target.classList;
      if (targetClassList.contains('active')) {
        target.classList.remove('active');
      }
    }
    setIsResouseClick(false);
    setIsSdkAppIdClick(false);
  };
  var itemBg = 'https://staticintl.cloudcachetci.com/cms/backend-cms/9SbQ507_dis_card_bg.png';
  (0, _react.useEffect)(function () {
    if (Object.keys(updateCard).length) {
      if (updateCard.cardItemIndex === clickKey) {
        setDiscount(updateCard.cardDiscount || discount);
        setOriginal(updateCard.cardOriginal || original);
        setQueryPrice(updateCard.isQueryPrice);
        setCreateOrder(updateCard.isCreateOrder);
      }
    }
  }, [updateCard]);
  (0, _react.useEffect)(function () {
    if (Object.keys(updateSdkAppInfo).length && hasSdkAppId) {
      if (updateSdkAppInfo.cardItemIndex === clickKey) {
        setResourceId(updateSdkAppInfo.resourceId || '');
        setLicenseExpireTime(updateSdkAppInfo.licenseExpireTime || '');
        setSdkAppId(updateSdkAppInfo.sdkAppId || 0);
      }
    }
  }, [updateSdkAppInfo]);
  (0, _react.useEffect)(function () {
    if (hasSdkAppId) {
      var sdkAppInfo = sdkAppInfos[0];
      onCardChangeSdkAppId({
        cardItemIndex: clickKey,
        sdkAppId: sdkAppInfo.ID
      });
    }
  }, [listArr]);
  (0, _react.useEffect)(function () {
    if (data.cardDiscount) {
      setDiscount(data.cardDiscount);
    }
    if (data.cardOriginal) {
      setOriginal(data.cardOriginal);
    }
    if (data.cardDefaultSelect) {
      setSelectProduce(data.cardDefaultSelect);
    }
    if (data.isQueryPrice !== undefined) {
      setQueryPrice(data.isQueryPrice);
    }
  }, [data]);
  var handleAdd = function handleAdd() {
    var nextBuyNem = purchaseNum + (goodsNum.step || 1);
    if (nextBuyNem <= goodsNum.max) {
      var skuId = selectResouse.skuId || '';
      var regionId = selectResouse.regionId || 0;
      var timeSpan = selectResouse.timeSpan || 0;
      var timeUnit = selectResouse.timeUnit || 0;
      var priceParam = JSON.parse(selectResouse.priceParam);
      priceParam.goodsNum = nextBuyNem;
      onNormalNumChange({
        cardItemIndex: clickKey,
        skuId: skuId,
        regionId: regionId,
        timeSpan: timeSpan,
        timeUnit: timeUnit,
        priceParam: JSON.stringify(priceParam),
        purchaseNum: nextBuyNem,
        eventId: eventId,
        ecId: ecId
      });
      setPurchaseNum(nextBuyNem);
    }
  };
  var handleReduce = function handleReduce() {
    var buyNextNum = purchaseNum - (goodsNum.step || 1);
    if (buyNextNum >= goodsNum.min) {
      var skuId = selectResouse.skuId || '';
      var regionId = selectResouse.regionId || 0;
      var timeSpan = selectResouse.timeSpan || 0;
      var timeUnit = selectResouse.timeUnit || 0;
      var priceParam = JSON.parse(selectResouse.priceParam);
      priceParam.goodsNum = buyNextNum;
      onNormalNumChange({
        cardItemIndex: clickKey,
        skuId: skuId,
        regionId: regionId,
        timeSpan: timeSpan,
        timeUnit: timeUnit,
        priceParam: JSON.stringify(priceParam),
        purchaseNum: buyNextNum,
        eventId: eventId,
        ecId: ecId
      });
      setPurchaseNum(buyNextNum);
    }
  };
  var handleBuyBtn = function handleBuyBtn() {
    orderInfo.eventId = eventId;
    orderInfo.ecId = ecId;
    var skuId = selectResouse.skuId || '';
    var regionId = selectResouse.regionId || 0;
    var timeSpan = selectResouse.timeSpan || 0;
    var timeUnit = selectResouse.timeUnit || 0;
    var priceParam = JSON.parse(selectResouse.priceParam);
    priceParam.goodsNum = purchaseNum;
    var param = {
      productName: moduleCode,
      limits: spuInfo,
      param: priceParam
    };
    var params = [JSON.stringify(param)];
    orderInfo.orderInfo = {
      price: discount,
      purchaseNum: purchaseNum,
      skuId: skuId,
      regionId: regionId,
      timeSpan: timeSpan,
      timeUnit: timeUnit,
      params: params
    };
    if (hasSdkAppId) {
      orderInfo.orderInfo = Object.assign(orderInfo.orderInfo, {
        resourceId: resourceId,
        licenseExpireTime: licenseExpireTime,
        sdkAppId: sdkAppId
      });
    }
    onNormalBuyClick(orderInfo, clickKey);
  };
  var handleFreeBuyBtn = function handleFreeBuyBtn() {
    var orderInfo = {
      event: eventId,
      commodity: ecId,
      isConnect: isConnect,
      hasNoModel: hasNoModel,
      eventType: eventType,
      href: href
    };
    onFreeBuyClick(orderInfo, clickKey);
  };
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item', {
      'item-hidden': supplement
    }),
    onMouseLeave: handleMouseLeave,
    style: layoutMode ? {
      minWidth: '30%',
      maxWidth: '33%'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box",
    style: {
      backgroundImage: "url(" + itemBg + ")"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__header', {
      'header-studentActivities-theme': colorTheme === 'studentActivities'
    })
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__header__title', {
      'header-title-studentActivities-theme': colorTheme === 'studentActivities',
      'no-desc': !desc
    })
  }, title), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__header__description', {
      'header-description-studentActivities-theme': colorTheme === 'studentActivities'
    })
  }, desc)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__price"
  }, queryPrice && !isNoDiscount ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__price-check', {
      'price-check-studentActivities-theme': colorTheme === 'studentActivities'
    })
  }, queryPriceText)) : ( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isNoDiscount ? ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "free-price"
  }, discount)) : ( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__price-discount', {
      'price-discount-studentActivities-theme': colorTheme === 'studentActivities'
    })
  }, /*#__PURE__*/_react["default"].createElement("span", null, "$"), discount), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__price-original"
  }, /*#__PURE__*/_react["default"].createElement("span", null, "$"), original)))))), textList.length > 0 && isLightHouse && !isNoDiscount && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__info"
  }, textList.map(function (item, key) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      className: "flex-discount-purchase-card__container__list__item__box__bg__body__info__list"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-discount-purchase-card__container__list__item__box__bg__body__info__list__title"
    }, item.title), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-discount-purchase-card__container__list__item__box__bg__body__info__list__text"
    }, item.text));
  }))), textList.length > 0 && isNoDiscount && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "free-card-info"
  }, textList === null || textList === void 0 ? void 0 : textList.map(function (item, index) {
    var _a = item || {},
      title = _a.title,
      text = _a.text;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__text_list',
      key: index
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__text_list_title'
    }, title), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__text_list_text', {
        'no-title': !title
      })
    }, text));
  }))
  // <div className="flex-discount-purchase-card__container__list__item__box__bg__body__info">
  //   {textList.map((item: any, key: number) => (
  //     <div
  //       key={key}
  //       className="flex-discount-purchase-card__container__list__item__box__bg__body__info__list"
  //     >
  //       <div className="flex-discount-purchase-card__container__list__item__box__bg__body__info__list__title">
  //         {item.title}
  //       </div>
  //       <div className="flex-discount-purchase-card__container__list__item__box__bg__body__info__list__text">
  //         {item.text}
  //       </div>
  //     </div>
  //   ))}
  // </div>
  ), description && isNoDiscount && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('list__description')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description || ''
    }
  }))), !isLightHouse && !isEmptyObject(spuInfo) && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout"
  }, hasSdkAppId && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__name"
  }, sdkAppText), sdkAppInfos.length >= 1 && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__resouse"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__resouse__dropdown"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__resouse__dropdown__button', {
      'dropdown-button-studentActivities-theme': colorTheme === 'studentActivities',
      active: isSdkAppIdClick
    }),
    onClick: toggleSdkAppIdActive,
    ref: dropDownButton
  }, /*#__PURE__*/_react["default"].createElement("p", null, sdkAppInfos[sdkAppIdSelectIndex].Name, sdkAppInfos[sdkAppIdSelectIndex].ID ? " -" + sdkAppInfos[sdkAppIdSelectIndex].ID : ''), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
    fill: "currentColor"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__resouse__dropdown__button__menu', {
      'button-menu-studentActivities-theme': colorTheme === 'studentActivities',
      'menu-active': isSdkAppIdClick
    })
  }, sdkAppInfos.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      onClick: function onClick(e) {
        return setSdkAppInfoChange(index, e);
      },
      key: index,
      className: index === sdkAppIdSelectIndex ? 'active' : ''
    }, item.Name, item.ID ? " -" + item.ID : '');
  })))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__name"
  }, resouseText), skuListWithTxt.length > 1 && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__resouse"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__resouse__dropdown"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__resouse__dropdown__button', {
      'dropdown-button-studentActivities-theme': colorTheme === 'studentActivities',
      active: isResouseClick
    }),
    onClick: toggleResouseActive,
    ref: dropDownButton
  }, /*#__PURE__*/_react["default"].createElement("p", null, skuListWithTxt[resouseSelectIndex].text), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
    fill: "currentColor"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__resouse__dropdown__button__menu', {
      'button-menu-studentActivities-theme': colorTheme === 'studentActivities',
      'menu-active': isResouseClick
    })
  }, skuListWithTxt.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      onClick: function onClick(e) {
        return setResouseChange(index, e);
      },
      key: index,
      className: index === resouseSelectIndex ? 'active' : ''
    }, item.text);
  })))), skuListWithTxt.length <= 1 && ( /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__value"
  }, resouseShow))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__name"
  }, timeText), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__item__value"
  }, timeShow)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num__tip"
  }, modelText.numText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num__oprate"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num__oprate__wrap"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: handleReduce,
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num__oprate__wrap__do', {
      'minus-disabled': purchaseNum <= goodsNum.min
    })
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "icon/16/less/normal",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "\u77E9\u5F62",
    fill: "#495770",
    x: "2",
    y: "7.2",
    width: "12",
    height: "1.6",
    style: purchaseNum <= goodsNum.min ? {
      fill: '#98A3B7'
    } : {}
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num__oprate__wrap__num"
  }, purchaseNum), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num__oprate__wrap__do add', {
      'plus-disabled': purchaseNum >= goodsNum.max
    }),
    onClick: handleAdd
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1"
  }, /*#__PURE__*/_react["default"].createElement("title", null, "mdpi/icon/16/plus/normal"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "icon/16/plus/normal",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 2.000000)",
    fill: "#495770",
    style: purchaseNum >= goodsNum.max ? {
      fill: '#98A3B7'
    } : {}
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    id: "\u77E9\u5F62",
    x: "0",
    y: "5.2",
    width: "12",
    height: "1.6"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    id: "\u77E9\u5F62",
    x: "5.2",
    y: "0",
    width: "1.6",
    height: "12"
  })))))), goodsNum.max < 999999 ? ( /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num__oprate__limit"
  }, modelText.limitText, goodsNum.max, modelText.unitText)) : ( /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__normal__layout__num__oprate__limit"
  }, modelText.infinityText))))))), timeInfoList.length >= 1 && isLightHouse && !isNoDiscount && ( /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__time"
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__time__title"
  }, timeText), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list__item__box__bg__body__time__dropdown"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__time__dropdown__button', {
      'dropdown-button-studentActivities-theme': colorTheme === 'studentActivities'
    }),
    onClick: function onClick(e) {
      return toggleActive(e);
    },
    ref: dropDownButton
  }, /*#__PURE__*/_react["default"].createElement("p", null, timeInfoList[timeSelectIndex].timeText), /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "8",
    height: "12",
    viewBox: "0 0 8 12",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99991 0.292908L0.585693 1.70712L4.87859 6.00001L0.585693 10.2929L1.99991 11.7071L7.70701 6.00001L1.99991 0.292908Z",
    fill: "currentColor"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card__container__list__item__box__bg__body__time__dropdown__button__menu', {
      'button-menu-studentActivities-theme': colorTheme === 'studentActivities'
    })
  }, timeInfoList.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      onClick: function onClick(e) {
        return setTimeAndPrice(index, e);
      },
      key: index,
      className: index === timeSelectIndex ? 'active' : ''
    }, item.timeText);
  })))))), /*#__PURE__*/_react["default"].createElement("div", __assign({
    className: queryPrice || createOrder ? 'flex-discount-purchase-card__container__list__item__box__bg__body__button-disable' : 'flex-discount-purchase-card__container__list__item__box__bg__body__button',
    onClick: function onClick() {
      if (!queryPrice && !createOrder) {
        // 非价格查询状态时，才可点击，这里可以预留给以后添加不可点击的提示
        if (isNoDiscount) {
          handleFreeBuyBtn();
        } else {
          if (!isLightHouse) {
            handleBuyBtn();
          } else {
            _onClick(clickKey, selectProduce, {
              discount: discount,
              original: original
            });
          }
        }
      }
    }
  }, extendProps || {}), createOrder ? ( /*#__PURE__*/_react["default"].createElement("span", {
    className: "loading"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 1024 1024",
    focusable: "false",
    "data-icon": "loading",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "loading-text"
  }, createOrderText))) : ( /*#__PURE__*/_react["default"].createElement("span", null, btnTxt))))))));
};
var DiscountPurchaseCard = function DiscountPurchaseCard(props) {
  var flexTitle = props.flexTitle,
    onClick = props.onClick,
    onCardChangeTime = props.onCardChangeTime,
    configuration = props.configuration,
    updateCard = props.updateCard,
    updateSdkAppInfo = props.updateSdkAppInfo,
    colorTheme = props.colorTheme,
    onNormalNumChange = props.onNormalNumChange,
    onNormalBuyClick = props.onNormalBuyClick,
    onFreeBuyClick = props.onFreeBuyClick,
    onCardChangeResouse = props.onCardChangeResouse,
    modelText = props.modelText,
    layoutMode = props.layoutMode,
    sdkAppInfos = props.sdkAppInfos,
    onCardChangeSdkAppId = props.onCardChangeSdkAppId;
  var layoutNum = layoutMode ? 3 : 4;
  var compatibleArr = configuration && configuration.length % layoutNum ? __spreadArrays(configuration, new Array(layoutNum - configuration.length % layoutNum).fill({
    supplement: true
  })) : configuration;
  var buyCon = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (buyCon === null || buyCon === void 0 ? void 0 : buyCon.current) {
      var buyConList = buyCon.current.childNodes;
      buyConList.forEach(function (item) {
        var buyConcurrent = item.getBoundingClientRect().height;
        item.childNodes[0].style.minHeight = buyConcurrent + "px";
      });
    }
  }, [compatibleArr]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('flex-discount-purchase-card', {
      'has-modTitle': flexTitle
    })
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-discount-purchase-card__container__list",
    ref: buyCon
  }, compatibleArr.map(function (data, key) {
    return /*#__PURE__*/_react["default"].createElement(DiscountPurchaseCardItem, {
      layoutMode: layoutMode,
      clickKey: key,
      key: key,
      data: data,
      updateCard: updateCard,
      updateSdkAppInfo: updateSdkAppInfo,
      onClick: onClick,
      onCardChangeTime: onCardChangeTime,
      colorTheme: colorTheme,
      onNormalNumChange: onNormalNumChange,
      modelText: modelText,
      onNormalBuyClick: onNormalBuyClick,
      onFreeBuyClick: onFreeBuyClick,
      onCardChangeResouse: onCardChangeResouse,
      sdkAppInfos: sdkAppInfos,
      onCardChangeSdkAppId: onCardChangeSdkAppId
    });
  }))));
};
DiscountPurchaseCard.displayName = 'TCIDiscountPurchaseCard';
var _default = exports["default"] = DiscountPurchaseCard;